import { PSMS_MCR_INVENTORY_FAILURE, PSMS_MCR_INVENTORY_LOADING, PSMS_MCR_INVENTORY_REQUEST, PSMS_MCR_INVENTORY_SUCCESS, PSMS_MCR_EVALUATION_DETAILS_REQUEST, PSMS_MCR_EVALUATION_DETAILS_LOADING, PSMS_MCR_EVALUATION_DETAILS_SUCCESS, PSMS_MCR_EVALUATION_DETAILS_FAILURE, PSMS_CLAIMS_SUMMARY_REQUEST, PSMS_CLAIMS_SUMMARY_SUCCESS, PSMS_CLAIMS_SUMMARY_FAILURE, PSMS_CLAIMS_SUMMARY_LOADING, PSMSCLAIMS_APPEALS_TREND_DATA_LOADING, PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS, PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING, PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS, PSMSCLAIMS_TOPREASONS_DATA_LOADING, PSMSCLAIMS_TOPREASONS_DATA_SUCCESS, PSMSCLAIMS_TOPREASONS_DATA_FAILURE, PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING, PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS, PSMSCLAIMS_OUTCOME_REASONS_SUCCESS, PSMSCLAIMS_OUTCOME_REASONS_LOADING, PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS, PSMSCLAIMS_SUBMISSION_REASONS_LOADING, PSMSCLAIMS_RECON_DETAILS_SUCCESS, PSMSCLAIMS_RECON_DETAILS_LOADING, PSMSCLAIMS_RECON_DETAILS_FAILURE, PSMSCLAIMS_OUTCOME_REASONS_FAILURE, PSMSCLAIMS_SUBMISSION_REASONS_FAILURE, PSMSCLAIMS_RECON_DATA_LOADING, PSMSCLAIMS_RECON_DATA_SUCCESS, PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE, PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE } from "@src/middleware/actions/actionTypes";

export interface PsmsClaimsState {
  appealTrendData: any[];
  appealTrendDataLoading: boolean;
  appealTrendDataError: any;
  claimsTrendData: any;
  claimsTrendDataLoading: boolean;
  claimsTrendDataError: any;
  topReasonsData?: any;
  topReasonsDataLoading?: boolean;
  topReasonsHeaderData?: any;
  topReasonsHeaderDataLoading?: boolean;
  claimsReconDataLoading?: boolean;
  claimsReconData?: { claimsReconDetail: any, claimsReconTat: any };
  // Outcome Volume
  outcomeReasons: any[];
  submissionReasons: any[];
  reconsiderationDetails: any;
  outcomeVolumeLoading: boolean;
  outcomeVolumeError: any;
  mcrInventoryData: any;
  mcrInventoryLoading: boolean;
  mcrInventoryError: string | null;
  evaluationDetailsData: any[];
  evaluationDetailsLoading: boolean;
  evaluationDetailsError: string | null;
  claimsSummaryData: {
    [key: string]: any;
  };
  claimsSummaryLoading: boolean;
  claimsSummaryError: string | null;
  claimsAppealsSubmissionData: any;
  claimsAppealsSubmissionLoading: boolean;
  claimsAppealsSubmissionError: string | null;
}

const initialState: PsmsClaimsState = {
  appealTrendData: [],
  appealTrendDataLoading: true,
  appealTrendDataError: null,
  claimsTrendData: {},
  claimsTrendDataLoading: true,
  claimsTrendDataError: null,
  topReasonsData: {},
  topReasonsDataLoading: true,
  topReasonsHeaderData: {},
  topReasonsHeaderDataLoading: true,
  claimsReconDataLoading: true,
  claimsReconData: { claimsReconDetail: null, claimsReconTat: null },
  // Outcome Volume
  outcomeReasons: [],
  submissionReasons: [],
  reconsiderationDetails: {},
  outcomeVolumeLoading: true,
  outcomeVolumeError: null,
  mcrInventoryData: null,
  mcrInventoryLoading: true,
  mcrInventoryError: null,
  evaluationDetailsData: [],
  evaluationDetailsLoading: true,
  evaluationDetailsError: null,
  claimsSummaryData: {},
  claimsSummaryLoading: true,
  claimsSummaryError: null,
  claimsAppealsSubmissionData: null,
  claimsAppealsSubmissionLoading: true,
  claimsAppealsSubmissionError: null,
};

export default function psmsClaimsReducer(
  state: PsmsClaimsState = initialState,
  action: { type: string; payload?: any }
): PsmsClaimsState {
  switch (action.type) {
    case PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS:
      return {
        ...state,
        claimsTrendData: action.payload,
      }
    case PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING:
      return {
        ...state,
        claimsTrendDataLoading: action.payload,
      }
    case PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE:
      return {
        ...state,
        claimsTrendData: {},
        claimsTrendDataLoading: false,
    }
    case PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS :
      return {
        ...state,
        appealTrendData: action.payload,
        appealTrendDataLoading: false,
        appealTrendDataError: null,
      };
    case PSMSCLAIMS_APPEALS_TREND_DATA_LOADING:
      return {
        ...state,
        appealTrendDataLoading: action.payload,
      };

    case PSMSCLAIMS_TOPREASONS_DATA_LOADING:
      return {
        ...state,
        topReasonsDataLoading: action.payload,
      }

    case PSMSCLAIMS_TOPREASONS_DATA_SUCCESS:
      return {
        ...state,
        topReasonsData: action.payload,
        topReasonsDataLoading: false,
      }

    case PSMSCLAIMS_TOPREASONS_DATA_FAILURE:
      return {
        ...state,
        topReasonsData: {},
        topReasonsDataLoading: false,
      }

    case PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR:
      return {
        ...state,
        topReasonsHeaderData: {},
        topReasonsHeaderDataLoading: false,
      }

    case PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS:
      return {
        ...state,
        topReasonsHeaderData: action.payload,
      }

    case PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING:
      return {
        ...state,
        topReasonsHeaderDataLoading: action.payload,
      }
    case PSMSCLAIMS_RECON_DATA_LOADING:
      return {
        ...state,
        claimsReconDataLoading: action.payload,
      }
    case PSMSCLAIMS_RECON_DATA_SUCCESS:
      return {
        ...state,
        claimsReconData: action.payload,
        claimsReconDataLoading: false,
      }

    // Outcome Volume cases
    case PSMSCLAIMS_OUTCOME_REASONS_LOADING:
      return { ...state, outcomeVolumeLoading: action.payload };
    case PSMSCLAIMS_OUTCOME_REASONS_SUCCESS:
      return { ...state, outcomeReasons: action.payload, outcomeVolumeError: null, outcomeVolumeLoading: false };
    case PSMSCLAIMS_OUTCOME_REASONS_FAILURE:
      return { ...state, outcomeReasons: [], outcomeVolumeError: action.payload, outcomeVolumeLoading: false };

    case PSMSCLAIMS_SUBMISSION_REASONS_LOADING:
      return { ...state, outcomeVolumeLoading: action.payload };
    case PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS:
      return { ...state, submissionReasons: action.payload, outcomeVolumeError: null, outcomeVolumeLoading: false };
    case PSMSCLAIMS_SUBMISSION_REASONS_FAILURE:
      return { ...state, submissionReasons: [], outcomeVolumeError: action.payload, outcomeVolumeLoading: false };

    case PSMSCLAIMS_RECON_DETAILS_LOADING:
      return { ...state, outcomeVolumeLoading: action.payload };
    case PSMSCLAIMS_RECON_DETAILS_SUCCESS:
      return { ...state, reconsiderationDetails: action.payload, outcomeVolumeError: null, outcomeVolumeLoading: false };
    case PSMSCLAIMS_RECON_DETAILS_FAILURE:
      return { ...state, reconsiderationDetails: {}, outcomeVolumeError: action.payload, outcomeVolumeLoading: false };
    case PSMS_MCR_INVENTORY_REQUEST:
      return { ...state, mcrInventoryLoading: true, mcrInventoryData: null, mcrInventoryError: null };
    case PSMS_MCR_INVENTORY_SUCCESS:
      return { ...state, mcrInventoryLoading: false, mcrInventoryData: action.payload, mcrInventoryError: null };
    case PSMS_MCR_INVENTORY_FAILURE:
      return { ...state, mcrInventoryLoading: false, mcrInventoryData: null, mcrInventoryError: action.payload };
    case PSMS_MCR_INVENTORY_LOADING:
      return { ...state, mcrInventoryLoading: action.payload };
    case PSMS_MCR_EVALUATION_DETAILS_REQUEST:
      return { ...state, evaluationDetailsLoading: true, evaluationDetailsData: [], evaluationDetailsError: null };
    case PSMS_MCR_EVALUATION_DETAILS_LOADING:
      return { ...state, evaluationDetailsLoading: action.payload };
    case PSMS_MCR_EVALUATION_DETAILS_SUCCESS:
      return { ...state, evaluationDetailsData: action.payload, evaluationDetailsLoading: false, evaluationDetailsError: null };
    case PSMS_MCR_EVALUATION_DETAILS_FAILURE:
      return { ...state, evaluationDetailsData: [], evaluationDetailsLoading: false, evaluationDetailsError: action.payload };

    case PSMS_CLAIMS_SUMMARY_REQUEST:
      return {
        ...state,
        claimsSummaryLoading: true,
        claimsSummaryData: {},
        claimsSummaryError: null,
      };

    case PSMS_CLAIMS_SUMMARY_LOADING:
      return {
        ...state,
        claimsSummaryLoading: action.payload,
      };

    case PSMS_CLAIMS_SUMMARY_SUCCESS:
      return {
        ...state,
        claimsSummaryData: {
          ...state.claimsSummaryData,
          ...action.payload,
        },
        claimsSummaryLoading: false,
        claimsSummaryError: null,
      };

    case PSMS_CLAIMS_SUMMARY_FAILURE:
      return {
        ...state,
        claimsSummaryData: {},
        claimsSummaryLoading: false,
        claimsSummaryError: action.payload,
      };

    case PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST:
      return {
        ...state,
        claimsAppealsSubmissionError: null,
      };

    case PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING:
      return {
        ...state,
        claimsAppealsSubmissionLoading: action.payload,
      };
    case PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS:
      return {
        ...state,
        claimsAppealsSubmissionData: action.payload,
        claimsAppealsSubmissionLoading: false,
        claimsAppealsSubmissionError: null,
      };
    case PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE:
      return {
        ...state,
        claimsAppealsSubmissionData: null,
        claimsAppealsSubmissionLoading: false,
        claimsAppealsSubmissionError: action.payload,
      };

    default:
      return state;
  }
}
